// extracted by mini-css-extract-plugin
module.exports = {"container":"share-file-modal_container__gvuD5","member-invitation":"share-file-modal_member-invitation__6_09E"};